import { addDays, isAfter } from 'date-fns';
import { newProductKeyType } from '../../interfaces/Element.interfaces';
import { browserStorage } from '../browserStorage.util';

export const checkHasNewProductNotification = ({
  id,
  startOnSaleDate,
  key,
  days = 7,
}: {
  id?: string;
  startOnSaleDate?: Date;
  key: newProductKeyType;
  days?: number;
}) => {
  if (!id || !startOnSaleDate) {
    return false;
  }

  // 지정된 일수 내에 있는지 확인
  const endDateForNewProduct = addDays(new Date(startOnSaleDate), days);
  const today = new Date();
  if (!isAfter(endDateForNewProduct, today)) {
    return false;
  }

  const prevNotificationString = browserStorage.getItem({ storageType: 'localStorage', itemKey: key });
  const prevNotification = prevNotificationString ? JSON.parse(prevNotificationString) : null;

  const isSameNotification =
    prevNotification && prevNotification.id === id && prevNotification.startOnSaleDate === startOnSaleDate;

  if (isSameNotification) {
    return false;
  }

  return true;
};
